

export const determineYearsOfCollege = (newNbrYearsCollege, currentNbrYearsCollege, relatedCareers, 
        currentCareerName, careerNbrMonths) => {

    var reducedNbrYearsCollege = 0;
    const careerNbrYears = (careerNbrMonths / 12).toFixed(1);
 
    const relatedCareerObj = relatedCareers.find(elem => elem.jobName === currentCareerName);
    if (relatedCareerObj){
        if (relatedCareerObj.stepStone === true ){
            if (careerNbrMonths >= 24){ 
                reducedNbrYearsCollege = +relatedCareerObj.collegeYears;
            }
        }else{
            reducedNbrYearsCollege = +relatedCareerObj.collegeYears;
            switch (true){
                case careerNbrMonths >= 20:
                    reducedNbrYearsCollege = 0;
                    break;
                case careerNbrMonths >= 15:
                    reducedNbrYearsCollege = +(+reducedNbrYearsCollege * .25).tofixed(0);
                    break;
                case careerNbrMonths >= 10:
                    reducedNbrYearsCollege = +(+reducedNbrYearsCollege * .50).toFixed(0);
                    break;
                case careerNbrMonths >= 5:
                    reducedNbrYearsCollege = +(+reducedNbrYearsCollege * .75).toFixed(0);
                    break;
                default:
                    break;
            }
        }
   }
                  
   return reducedNbrYearsCollege;
   
}





